import PropTypes from 'prop-types';
import './index.less';

function AlarmStatusImg({ title, image }) {
  return (
    <div className="alarmStatusImg">
      <label className="alarmStatusImg--title">{title}</label>
      <img src={image} alt={'Alarm Status Image'} className="alarmStatusImg--image" />
    </div>
  );
}

AlarmStatusImg.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  image: PropTypes.string,
};

export default AlarmStatusImg;
